import { AppContextType, AppType } from "@microsoft/metaos-appcontextutils";
import { refreshAuthTokenIfRequired } from "../../appContextProvider";
import { StateSlice } from "./app";

export type AuthProps = {
  authenticated: boolean;
  context: AppContextType;
};

export type AuthState = AuthProps & {
  setAuthenticated: (authenticated: boolean) => void;
  setContext: (context: AppContextType) => void;
  updateContext: () => Promise<AppContextType>;
};

export const createAuthState: StateSlice<AuthState> = (set, get) => ({
  authenticated: false as boolean,
  setAuthenticated: (authenticated: boolean) =>
    set({ authenticated }, false, {
      type: "setAuthenticated",
      authenticated,
    }),
  context: {
    appType: AppType.standAlone,
  },
  setContext: (context: AppContextType) => {
    const { appInsights } = get();
    appInsights.addTelemetryInitializer((item) => {
      item.tags = item.tags || [];
      item.tags["sessionId"] = context.sessionId;
      item.tags["appType"] = context.appType;
      item.tags["correlationId"] = context.authData?.correlationId;
      item.tags["userId"] = context.authData?.account?.username;
    });
    set({ context }, false, {
      type: "setContext",
      context: {
        appType: context.appType,
        sessionId: context.sessionId,
      },
    });
  },
  updateContext: async () => {
    const { context, setContext } = get();
    const updatedContext = await refreshAuthTokenIfRequired(context);
    setContext(updatedContext);
    return updatedContext;
  },
});
